module.exports = __webpack_public_path__ + "static/media/Project3_Fig4.e31fd762.png";